import api from "@/api";

export const descontosApi = {
  async getMatriz(params) {
    const { data } = await api.get("/cartoes/descontos/matriz", { params });
    return data;
  },

  async updateDesconto(qr_code, restaurante_id, desconto) {
    const { data } = await api.put("/cartoes/desconto", { qr_code, restaurante_id, desconto });
    return data;
  },

  async getPerfil(qr_code) {
    const { data } = await api.get(`/cartoes/perfil/${qr_code}`);
    return data;
  },

  async iniciarBulk(desconto, qrCodes, restauranteIds) {
    const { data } = await api.post("/bulk/iniciar", { desconto, qrCodes, restauranteIds });
    return data;
  },

  async getBulkStatus(bulkId) {
    const { data } = await api.get(`/bulk/detalhes/${bulkId}/temp`);
    return data;
  },

  async listarBulks() {
    const { data } = await api.get("/bulk/listar");
    return data;
  },

  async getBulkErros(bulkId) {
    const { data } = await api.get(`/bulk/detalhes/${bulkId}`);
    return data;
  },
};
